import { Component, OnInit, Optional } from '@angular/core';
import { IndexedService } from '@damofire/data-commons';
import { IdbAuthStoreService } from '@damofire/data-security';
import { LoaderComponent, MainLayoutComponent, UixCommonsModule } from '@damofire/uix-commons';
import packageInfo from 'package.json';

@Component({
  templateUrl: 'force-update.component.html',
  standalone: true,
  imports: [UixCommonsModule, MainLayoutComponent, LoaderComponent],
})
export class ForceUpdateComponent implements OnInit {
  constructor(
    private readonly idbAuthStoreService: IdbAuthStoreService,
    @Optional() private readonly idbService?: IndexedService,
  ) {}

  ngOnInit(): void {
    console.log('Emptying storage');
    this.emptyStorage();
    console.log('Clearing cookies');
    this.clearCookies();
    console.log('Unregistering service workers');
    this.unregisterServiceWorker();
    console.log('Deleting idb');
    this.deleteIdb().finally(() => (location.href = `/?version=${packageInfo.version}`));
  }

  private emptyStorage(): void {
    localStorage.clear();
    sessionStorage.clear();
  }

  private async deleteIdb(): Promise<void> {
    await this.idbService?.waitAllDone();
    await this.idbAuthStoreService.close();

    const dbs = await indexedDB.databases();
    const promises = dbs
      .filter((db) => !db.name.includes('firebase'))
      .map((db) => {
        return new Promise((resolve, reject) => {
          const req = indexedDB.deleteDatabase(db.name);
          const rejection = (e): void => {
            console.error(db.name, e);
            reject(e);
          };
          req.onsuccess = resolve;
          req.onerror = rejection;
          req.onblocked = rejection;
        });
      });
    await Promise.all(promises);
  }

  private clearCookies(): void {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const splitCookie = cookie.split('=');
      document.cookie = splitCookie[0].trim() + '=;expires=Fri, 20 Aug 2021 00:00:00 UTC';
    }
  }

  private unregisterServiceWorker(): void {
    navigator.serviceWorker?.getRegistrations().then(async function (registrations) {
      for (const registration of registrations) {
        await registration.unregister();
      }
    });
  }
}
